/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAiMessageSuggestion } from '../../models/api-response-paged-result-ai-message-suggestion';
import { PagedRequestString } from '../../models/paged-request-string';

export interface SearchAiSuggestions$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestString
}

export function searchAiSuggestions(http: HttpClient, rootUrl: string, params: SearchAiSuggestions$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAiMessageSuggestion>> {
  const rb = new RequestBuilder(rootUrl, searchAiSuggestions.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAiMessageSuggestion>;
    })
  );
}

searchAiSuggestions.PATH = '/v1/api/ui/ai-message-suggestion/search';
